var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgDlsPreventive = function SvgDlsPreventive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.983 10.974a11.115 11.115 0 01-2.22 6.606c-1.384 1.857-3.152 3.188-5.395 3.86a1.218 1.218 0 01-.745 0 10.16 10.16 0 01-5.192-3.596A11.144 11.144 0 014 10.849V8.607 3.07c-.014-.093 5.318-.093 15.997 0 .004 4.116 0 6.75-.014 7.904z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.33 7.07v2.666h2.667v2.667H13.33v2.667h-2.667v-2.667H7.997V9.737h2.666V7.07h2.667z",
    fill: "#FFF"
  })));
};

export default __webpack_public_path__ + "static/media/DLS_Preventive.7aa460c6.svg";
export { SvgDlsPreventive as ReactComponent };